import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
//MaterialUI Imports
import {
    Alert,
    Autocomplete,
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Snackbar,
    Stack,
    TextField,
    Tooltip,
    Typography,
    CardHeader,
    InputLabel,
    Card,
    CardContent,
    FormControl,
    Select,
    MenuItem
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MainCard from 'ui-component/cards/MainCard';

//icon imports
import PaymentsIcon from '@mui/icons-material/Payments';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FunctionsIcon from '@mui/icons-material/Functions';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

//services imports
import useEmployeeService from 'services/useEmployeeService';
import useSESalarySlabsService from 'services/useSESalarySlabsService';
import useSEFieldExpencessService from 'services/useSEFieldExpencessService';
//import useAmountTransactionService from 'services/useAmountTransactionService';
//project imports
import { roles } from 'store/constant';
import { LoadingButton } from '@mui/lab';
import SECard from './SECard';

//third pary imports

const SESalarySheets = (props) => {
    const { selectedRole, selectedLocation, selectedMonth, selectedYear } = props;
    const theme = useTheme();
    const navigate = useNavigate();
    //const { userId } = useSelector((state) => state.userReducer);
    //states
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState();
    const [salarySlabDetails, setSalarySlabDetails] = useState();
    const [filedExpensesDetails, setFiledExpensesDetails] = useState();

    //services
    const { getEmployees } = useEmployeeService();
    const { getSESalarySlab } = useSESalarySlabsService();
    const { getSEFieldExpences } = useSEFieldExpencessService();
    //const { getAmountTransactionPendingAmount } = useAmountTransactionService();
    //handlers
    const handleGetEmployees = () => {
        //console.log('DATAAA', selectedRole, selectedLocation);
        getEmployees(selectedRole, selectedLocation, 0, 100000)
            .then((response) => {
                // console.log(response);
                if (response.status == 200) {
                    setEmployees(response.data.users);
                } else {
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleGetSalarySlabs = () => {
        getSESalarySlab()
            .then((response) => {
                if (response.status == 200) {
                    if (response.data.list.length > 0) {
                        setSalarySlabDetails(response.data.list[0]);
                    }
                } else {
                    console.log(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleGetFieldExpenses = () => {
        getSEFieldExpences(salarySlabDetails.id)
            .then((response) => {
                if (response.status == 200) {
                    setFiledExpensesDetails(response.data.list);
                } else {
                    console.log(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    //use effects
    useEffect(() => {
        handleGetEmployees();
        handleGetSalarySlabs();
    }, [selectedRole, selectedLocation]);

    useEffect(() => {
        if (salarySlabDetails) {
            handleGetFieldExpenses();
        }
    }, [salarySlabDetails]);

    return (
        <Box>
            <Grid container spacing={2}>
                {employees ? (
                    <>
                        {employees.map((employee, index) => {
                            return (
                                <Grid item xs={12} md={6} key={index}>
                                    <SECard
                                        employee={employee}
                                        salarySlabDetails={salarySlabDetails}
                                        filedExpensesDetails={filedExpensesDetails}
                                        onRefresh={() => {
                                            handleGetSalarySlabs();
                                            handleGetFieldExpenses();
                                            handleGetPendingAmount();
                                        }}
                                        location={selectedLocation}
                                        month={selectedMonth}
                                        year={selectedYear}
                                    />
                                </Grid>
                            );
                        })}
                    </>
                ) : null}
            </Grid>
        </Box>
    );
};

export default SESalarySheets;
